import { render, staticRenderFns } from "./price_chart.vue?vue&type=template&id=6ffccd0c&scoped=true&"
import script from "./price_chart.vue?vue&type=script&lang=js&"
export * from "./price_chart.vue?vue&type=script&lang=js&"
import style0 from "./price_chart.vue?vue&type=style&index=0&id=6ffccd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffccd0c",
  null
  
)

export default component.exports